<template>
  <div
    class="ui top-segment segment"
    :class="{ 'top attached': !topAttached, attached: topAttached }"
  >
    <div class="ui basic segments">
      <div class="ui horizontal segments">
        <Spinny :promise="loadingPromise" />
        <div class="ui meta segment">
          <label>{{ $t('PUBLICATION_TYPE') }}</label>
          <div>
            {{ publicationTypeMap[publication.type] && publicationTypeMap[publication.type].name }}
          </div>
        </div>
        <div class="ui meta segment w-1/4">
          <label>{{ $t('PUBLICATION_NAME') }}</label>
          <div>{{ publication.name }}</div>
        </div>
        <div class="ui meta segment">
          <label>{{ $tc('LICENSE', 1) }}</label>
          <div>{{ publication.license && publication.license.name }}</div>
        </div>
        <div class="ui meta segment" v-if="categories">
          <label>{{ $tc('CATEGORY', 1) }}</label>
          <div>
            {{ categories[publication.category] && categories[publication.category].name }}
          </div>
        </div>
        <div class="ui meta segment" v-if="applications">
          <label class="capitalize-fl">{{ $tc('APPLICATION', 1) }}</label>
          <div>
            {{
              applications[publication.application] && applications[publication.application].name
            }}
          </div>
        </div>
      </div>
      <div class="ui meta segment" v-if="showAbstract && publication.abstract">
        <label>{{ $t('ABSTRACT') }}</label>
        <div>{{ publication.abstract }}</div>
      </div>
      <div class="ui meta segment" v-if="!condensed && publication.description">
        <label>{{ $t('PUBLICATION_DESCRIPTION') }}</label>
        <div v-html="renderMarkdown(publication.description, publication.origin.hub)" />
      </div>
      <div
        class="ui meta segment"
        v-if="
          (!condensed || showReleaseNote) && publication.releaseNote && publication.releaseNote.note
        "
      >
        <label>{{ $t('RELEASENOTE') }}</label>
        <div v-html="renderMarkdown(publication.releaseNote.note, publication.origin.hub)" />
      </div>
      <div class="ui horizontal segments" v-if="!condensed">
        <div class="ui meta segment">
          <label>{{ $t('AUTHOR') }}</label>
          <div v-if="publication.author.email">
            <a :href="publication.author.email">
              {{ publication.author.name }}
            </a>
          </div>
          <div v-else-if="publication.author.name">{{ publication.author.name }}</div>
          <div v-else>{{ $t('UNKNOWN') }}</div>
        </div>
        <div class="ui meta segment w-1/4">
          <label>{{ $t('PUBLICATION_VERSION') }}</label>
          <div>{{ publication.releaseNote.version }}</div>
          <version
            :type="'flow'"
            :identifier="publication.origin.identifier"
            :changeId="publication.origin.change"
            :appId="appId"
          />
        </div>
        <div class="ui meta segment w-1/4" v-if="hubs">
          <label>{{ $tc('HUB', 1) }}</label>
          <div>
            <router-link
              :to="{
                name: 'hub',
                params: { hubId: hubs[publication.origin.hub].hub.id, at: 'details' }
              }"
            >
              {{ hubs[publication.origin.hub].hub.name }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.meta {
  label {
    text-transform: uppercase;
    font-size: 0.7em;
    font-weight: bold;
  }
}
.top-segment {
  padding: 0px !important;
}
</style>

<script>
// @flow
import Vue from 'vue'
import { Hub } from 'services'
import Version from './Version'
import { Spinny } from 'ui'

import marked from 'marked'
import DOMPurify from 'dompurify'
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css'

const markedOptions = {
  highlight: function(code, lang) {
    const language = hljs.getLanguage(lang) ? lang : 'plaintext'
    return hljs.highlight(code, { language }).value
  },
  smartypants: true,
  smartLists: true
}

export default {
  name: 'publication',

  props: [
    'publication',
    'hubs',
    'categories',
    'applications',
    'licenses',
    'condensed',
    'showAbstract',
    'showReleaseNote',
    'topAttached',
    'loadingPromise'
  ],

  components: { Version, Spinny },

  data() {
    return {
      publicationTypes: Hub.publicationTypes()
    }
  },

  computed: {
    publicationTypeMap() {
      return _.keyBy(this.publicationTypes, 'id')
    },
    appId() {
      return this.$route.params.appId
    }
  },

  methods: {
    renderMarkdown(md, origin) {
      const h = this.hubs ? this.hubs[origin] : null
      const options = { ...markedOptions, baseUrl: h && h.hub.url }
      if (md) return DOMPurify.sanitize(marked(md, options))
    }
  }
}
</script>
